import React, {useCallback} from 'react'
import {ButtonLink, TrashBinIcon} from '@modifi/ui'

type DeleteSellerBankAccountButtonProps = {
  onClick: () => void
}

const DeleteSellerBankAccountButton: React.FC<DeleteSellerBankAccountButtonProps> = ({onClick}) => {
  const handleClick = useCallback(
    (e: React.UIEvent) => {
      e.preventDefault()
      onClick()
    },
    [onClick]
  )
  return (
    <ButtonLink
      onClick={handleClick}
      iconOnly
      transparent
      type="button"
      data-target="delete-seller-bank-account"
    >
      <TrashBinIcon />
    </ButtonLink>
  )
}

export default DeleteSellerBankAccountButton
